export default {
    Desfiliar: axios.create({
      baseURL: process.env.VUE_APP_ENDPOINT_API + "desfiliar"
    })
  }


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/Desfiliar.js
// module id = vr7M
// module chunks = 18